import React, { useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import Button from './ui/Button';

export default function AgeGateModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('age_verified')) setOpen(true);
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-zinc-900 p-6 text-center shadow-2xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-rose-500/15">
          <ShieldAlert className="h-6 w-6 text-rose-400" />
        </div>
        <h2 className="mb-2 text-xl font-semibold text-white">Conteúdo para maiores</h2>
        <p className="mb-5 text-sm text-zinc-400">
          Este site contém conteúdo adulto. Confirme sua idade.
        </p>
        <div className="flex gap-3">
          <Button
            fullWidth
            onClick={() => {
              localStorage.setItem('age_verified', '1');
              setOpen(false);
            }}
          >
            Tenho 18+
          </Button>
          <Button as="a" href="https://google.com" variant="secondary" fullWidth>
            Sair
          </Button>
        </div>
      </div>
    </div>
  );
}
